import { motion, AnimatePresence } from "framer-motion";

const formatRupiah = (number) => {
  return number ? Number(number).toLocaleString("id-ID") : 0;
};

const SwipeShippingOption = ({
  open,
  onClose,
  formatShippingEstimationDisplay,
  tempSelectedShipping,
  setTempSelectedShipping,
  buildShippingFieldsFromOption,
  shippingGroups,
  selectedShippingKey,
  getOptionKey,
  handleConfirmShipping,
}) => {
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-[9999]"
            onClick={onClose}
          />

          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl z-[9999] max-h-[70vh] flex flex-col shadow-2xl text-base"
          >
            <div className="flex flex-col gap-3 px-4 pt-4">
              <div className="flex w-full justify-center">
                <div className="bg-gray-200 w-[25%] h-1.5 rounded-full"></div>
              </div>
              <h2 className="text-lg font-semibold text-slate-900 pb-2">
                Opsi Pengiriman
              </h2>
            </div>
            <div className="flex-1 p-3 overflow-y-auto">
              <div className="overflow-y-auto flex-1 px-1 pb-12">
                {shippingGroups.length === 0 ? (
                  <p className="text-gray-400 text-center py-8">
                    Tidak ada opsi pengiriman tersedia
                  </p>
                ) : (
                  shippingGroups.map((group) => (
                    <div key={group.key} className="mb-4">
                      <h2 className="font-semibold text-slate-600 text-sm mb-2 uppercase tracking-wide">
                        {group.label}
                      </h2>
                      <div className="flex flex-col gap-2">
                        {group.options.map((option, idx) => {
                          const optionKey = getOptionKey(option, group.key);
                          const estimationLine =
                            formatShippingEstimationDisplay(
                              option.estimation ?? option.etd ?? "",
                            );
                          const currentKey = tempSelectedShipping
                            ? getOptionKey(
                                {
                                  code: tempSelectedShipping.shipment_code,
                                  service_type:
                                    tempSelectedShipping.shipping_service_type,
                                },
                                tempSelectedShipping.shipping_group_code,
                              )
                            : selectedShippingKey;
                          const isSelected = optionKey === currentKey;
                          return (
                            <div
                              key={idx}
                              onClick={() =>
                                setTempSelectedShipping(
                                  buildShippingFieldsFromOption(
                                    option,
                                    group.key,
                                  ),
                                )
                              }
                              className={`w-full rounded-xl border flex items-center justify-between px-3 py-2 cursor-pointer ${
                                isSelected
                                  ? "border-secondary bg-secondaryActive"
                                  : "border-slate-300 bg-slate-100"
                              }`}
                            >
                              <div className="flex items-center gap-2">
                                <input
                                  type="radio"
                                  readOnly
                                  checked={isSelected}
                                  className="w-5 h-5 text-secondary focus:ring-secondary"
                                />
                                <div className="flex flex-col">
                                  <p className="font-semibold text-slate-700 text-md">
                                    {group.key === "instant"
                                      ? option.name
                                      : option.service_name || option.name}
                                  </p>
                                  <p className="text-sm text-gray-500">
                                    {estimationLine === "-"
                                      ? "Estimasi -"
                                      : `Estimasi ${estimationLine}`}
                                  </p>
                                </div>
                              </div>
                              <p className="font-semibold text-slate-700 text-md flex-shrink-0 tabular-nums">
                                Rp{formatRupiah(option.price)}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))
                )}
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3">
                <button
                  onClick={handleConfirmShipping}
                  disabled={!tempSelectedShipping && !selectedShippingKey}
                  className="h-[40px] border border-secondary flex items-center gap-2 justify-center bg-secondary text-white w-full tracking-wide font-medium rounded-lg focus:outline-none hover:bg-secondaryHover disabled:bg-slate-300 disabled:border-slate-300 disabled:cursor-default"
                >
                  Konfirmasi
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default SwipeShippingOption;
